import React from "react";

export default function Stat({ label, value, hint, tone, children }) {
  return (
    <div
      className={tone ? `stl-card stl-stat stl-stat--${tone}` : "stl-card stl-stat"}
      role="group"
      aria-label={typeof label === "string" ? label : undefined}
    >
      <span className="stl-stat__label">{label}</span>
      <span className="stl-stat__value">{value}</span>
      {hint && <span className="stl-stat__hint">{hint}</span>}
      {children}
    </div>
  );
}
